export const toDate = (ts) => {
  if (!ts) return null;
  if (ts instanceof Date) return ts;
  const s = String(ts);
  return new Date(/Z|[+-]\d\d:\d\d$/.test(s) ? s : s + 'Z');
};

export const formatTime = (ts) => {
  const d = toDate(ts);
  return d ? d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '';
};

export const formatFullDate = (ts) => {
  const d = toDate(ts);
  return d ? d.toLocaleString([], { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';
};

const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();

export const dayLabel = (ts) => {
  const d = toDate(ts);
  if (!d) return '';
  const now = new Date();
  if (sameDay(d, now)) return 'Today';
  const y = new Date(now); y.setDate(now.getDate() - 1);
  if (sameDay(d, y)) return 'Yesterday';
  return d.toLocaleDateString([], { month: 'short', day: 'numeric', year: d.getFullYear() === now.getFullYear() ? undefined : 'numeric' });
};

// Decorate messages with day dividers, grouping and the "new messages" marker
export const buildTimeline = (messages, lastReadAt, myId, firstUnreadId) => {
  const lastRead = toDate(lastReadAt);
  const out = [];
  let prev = null;
  messages.forEach((m) => {
    const d = toDate(m.createdAt);
    if (!prev || !sameDay(toDate(prev.createdAt), d)) out.push({ kind: 'day', id: `day-${m.id}`, label: dayLabel(m.createdAt) });
    if (firstUnreadId ? m.id === firstUnreadId : (lastRead && m.senderId !== myId && d > lastRead && !(prev && toDate(prev.createdAt) > lastRead))) {
      out.push({ kind: 'new', id: `new-${m.id}` });
    }
    const grouped = prev && prev.senderId === m.senderId && sameDay(toDate(prev.createdAt), d)
      && d - toDate(prev.createdAt) < 5 * 60 * 1000 && !m.replyTo && out[out.length - 1]?.kind === 'msg';
    out.push({ kind: 'msg', id: m.id, msg: m, grouped: !!grouped });
    prev = m;
  });
  return out;
};

export const mergeMessages = (existing, incoming) => {
  const map = new Map(existing.map((m) => [m.id, m]));
  incoming.forEach((m) => { if (m.deleted) map.delete(m.id); else map.set(m.id, { ...(map.get(m.id) || {}), ...m }); });
  return Array.from(map.values()).sort((a, b) => toDate(a.createdAt) - toDate(b.createdAt));
};

export const latestStamp = (messages) => {
  let best = null;
  messages.forEach((m) => {
    [m.updatedAt, m.createdAt].forEach((t) => { const d = toDate(t); if (d && (!best || d > best)) best = d; });
  });
  return best ? best.toISOString() : null;
};

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Split content into text + mention tokens for rendering (`@everyone` when mentionsAll)
export const tokenizeMentions = (content, mentions = [], mentionsAll = false) => {
  if ((!mentions.length && !mentionsAll) || !content) return [{ text: content }];
  const names = mentions.map((m) => m.displayName).filter(Boolean).sort((a, b) => b.length - a.length);
  if (mentionsAll) names.push('everyone');
  const re = new RegExp(`@(${names.map(escapeRe).join('|')})(?![\\w])`, 'gi');
  const parts = [];
  let last = 0; let match;
  while ((match = re.exec(content)) !== null) {
    if (match.index > last) parts.push({ text: content.slice(last, match.index) });
    const isAll = match[1].toLowerCase() === 'everyone';
    parts.push({ mention: isAll ? { id: '*', displayName: 'everyone' } : mentions.find((m) => m.displayName === match[1]), text: match[0] });
    last = match.index + match[0].length;
  }
  if (last < content.length) parts.push({ text: content.slice(last) });
  return parts;
};
